import { useTranslation } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { isComsEnabled, isCustomChartEnabled, isCustomizeEmailFromAdminEnabled, isCustomRegionEnabled, isModularHomeExperienceEnabled, } from '@thoughtspot/session-service';
import React, { Suspense, useMemo, useState } from 'react';
import { BasePageContext } from "../../../contexts/basepage-context";
import { EmailCustomizations, HelpCustomization, } from '../../application-settings';
import { ChartCustomization } from '../../chart-customization';
import { HomePageDiscovery } from '../../home-page-discovery';
import { AdminPageHeader } from '../admin-page-header/admin-page-header';
import { CustomizationsTranslationKeys } from '../constants';
import styles from './customizations.module.scss';
const StyleTab = ({ orgViewModeType, }) => {
    const { styleComponents } = BasePageContext();
    const { StyleComponentsContainer } = styleComponents || {};
    if (!StyleComponentsContainer) {
        return (React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)));
    }
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)) },
        React.createElement(StyleComponentsContainer, { orgViewModeType: orgViewModeType })));
};
export const CustomizationsContainer = ({ currentOrgId, orgViewModeType, }) => {
    const { t } = useTranslation();
    const { metricsService } = BasePageContext();
    const [activeTab, setActiveTab] = useState('style');
    const tabs = useMemo(() => [
        { id: 'style', title: t(CustomizationsTranslationKeys.TAB_STYLE) },
        {
            id: 'chart',
            title: t(CustomizationsTranslationKeys.TAB_CHART),
            show: isCustomChartEnabled() || isCustomRegionEnabled(),
        },
        {
            id: 'homepage',
            title: t(CustomizationsTranslationKeys.TAB_HOMEPAGE),
            show: isModularHomeExperienceEnabled(),
        },
        {
            id: 'email',
            title: t(CustomizationsTranslationKeys.TAB_EMAIL),
            show: isComsEnabled() && isCustomizeEmailFromAdminEnabled(),
        },
        { id: 'help', title: t(CustomizationsTranslationKeys.TAB_HELP) },
    ], [t]);
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        metricsService.collectEvent(new UserAction(userActionTypeEnum.CLICK), {
            trackId: `admin_customizations_${tabId}`,
        });
    };
    const renderTabContent = () => {
        switch (activeTab) {
            case 'style':
                return React.createElement(StyleTab, { orgViewModeType: orgViewModeType });
            case 'chart':
                return React.createElement(ChartCustomization, { currentOrgId: currentOrgId });
            case 'homepage':
                return React.createElement(HomePageDiscovery, { orgViewModeType: orgViewModeType });
            case 'email':
                return React.createElement(EmailCustomizations, { currentOrgId: currentOrgId });
            case 'help':
                return React.createElement(HelpCustomization, null);
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: styles.customizationsContainer },
        React.createElement(AdminPageHeader, { title: t(CustomizationsTranslationKeys.TITLE), tabs: tabs, selectedTabId: activeTab, onTabChange: handleTabChange, titleTestId: "customizations-title", tabTestIdPrefix: "customizations-tab" }),
        React.createElement("div", { className: styles.tabContent }, renderTabContent())));
};
//# sourceMappingURL=customizations.container.js.map